import { render, staticRenderFns } from "./Curso.vue?vue&type=template&id=31a67122&scoped=true"
import script from "./Curso.vue?vue&type=script&lang=js"
export * from "./Curso.vue?vue&type=script&lang=js"
import style0 from "./Curso.vue?vue&type=style&index=0&id=31a67122&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a67122",
  null
  
)

export default component.exports